import React, { useContext, useEffect, useRef, useState } from "react";
import "./Motor.css";
import MotorSlider from "./Sliders/MotorSlider";
import { Context } from "../../../context/Context";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

const Motor = ({
  equipment_id,
  closeSelectEquipmentRef,
  closeSelectOutputEquipmentRef,
  data,
  setData,
}) => {
  const { equipmentButtons, devices } = useContext(Context);

  const [buttons, setButtons] = useState([]);
  const [selectedButton, setSelectedButton] = useState({
    state: 0,
    sliderValue: 0,
  });

  useEffect(() => {
    // setIsLoading(true);
    // AllEquipmentButton({
    //   equipment_id: equipment_id,
    // }).then(({ data }) => {
    //   setButtons(data.equipment_buttons);
    //   setIsLoading(false);
    // });

    setButtons(
      equipmentButtons.filter((eq_btn) => eq_btn.equipment_id == equipment_id)
    );
  }, [equipmentButtons, equipment_id]);

  const handleChangeMotorStatus = () => {
    setSelectedButton((prev) => ({
      ...prev,
      state: prev.state ? 0 : 1,
    }));
  };

  const handleChangeSliderValue = (val) => {
    setSelectedButton((prev) => ({
      ...prev,
      sliderValue: val < 0 ? val + 256 : val,
    }));
  };

  const handleSubmit = () => {
    const button = buttons[0];
    const device = devices.find((d) => d.id == button.device_id);
    if (!device) {
      return;
    }
    let data1 = 9;
    let data2 = selectedButton.state;
    let data3 = 0;
    let data4 = selectedButton.sliderValue;

    setData({
      icon: null,
      name: button.name,
      data: [2, data1, data2, data3, data4],
      device: device,
    });
    setSelectedButton({
      state: 0,
      sliderValue: 0,
    });
    closeSelectEquipmentRef.current.click();
    closeSelectOutputEquipmentRef.current.click();
  };

  return (
    <div className="card h-100" style={{backgroundColor: 'transparent', boxShadow: 'unset'}}>
      <div
        className="card-header d-flex align-items-center justify-content-between border-bottom p-0 pt-2"
        style={{ zIndex: 1, top: '0' }}
      >
        <h5>{buttons?.[0]?.equipment?.name ?? ""}</h5>
        <button
          type="button"
          className="btn btn-icon btn-success-app"
          onClick={handleSubmit}
        >
          <span className="tf-icons bx bx-check"></span>
        </button>
      </div>
      <div className="card-body scrollbar p-0">
        {/* <SimpleBar style={{ maxHeight: "100%", padding: "1.5rem" }}> */}
          <div className="row motor-box rounded-3">
            <div className="col-12">
              <div className="d-flex justify-content-around">
                <div>مشعل</div>
                <div>
                  <div className="form-check form-switch mb-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="flexSwitchCheckChecked"
                      checked={selectedButton.state ? "checked" : ""}
                      onChange={handleChangeMotorStatus}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 text-center slider-power">
              <MotorSlider value={0} setValue={handleChangeSliderValue} />
            </div>
            {/* <div className="col-12">
              <div className="d-flex justify-content-start flex-wrap">
                <div className="motor-status">
                  <p className="text-center">دمای بیرون</p>
                  <p className="text-center" dir="ltr">
                    -
                  </p>
                  <img src="/assets/img/app-icons/Jf.png" alt="" />
                  <p className="text-center">پمپ 3</p>
                  <p className="text-center" dir="ltr">
                    -
                  </p>
                  <p className="text-center" dir="ltr">
                    -
                  </p>
                </div>
                <div className="motor-status">
                  <p className="text-center">دمای موتورخانه</p>
                  <p className="text-center" dir="ltr">
                    -
                  </p>
                  <img src="/assets/img/app-icons/Jf.png" alt="" />
                  <p className="text-center">پمپ 2</p>
                  <p className="text-center" dir="ltr">
                    -
                  </p>
                  <p className="text-center" dir="ltr">
                    -
                  </p>
                </div>
                <div className="motor-status">
                  <p className="text-center">دمای تنظیم</p>
                  <p className="text-center" dir="ltr">
                    -
                  </p>
                  <img src="/assets/img/app-icons/Jf.png" alt="" />
                  <p className="text-center">پمپ 1</p>
                  <p className="text-center" dir="ltr">
                    -
                  </p>
                  <p className="text-center" dir="ltr">
                    -
                  </p>
                </div>
              </div>
            </div> */}
          </div>
        {/* </SimpleBar> */}
      </div>
    </div>
  );
};

export default React.memo(Motor);
